import { render } from "./TradingRules.vue?vue&type=template&id=62c84bff&scoped=true&ts=true"
import script from "./TradingRules.vue?vue&type=script&lang=ts"
export * from "./TradingRules.vue?vue&type=script&lang=ts"

import "./TradingRules.vue?vue&type=style&index=0&id=62c84bff&scoped=true&lang=css"

import exportComponent from "D:\\客户端h5\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62c84bff"]])

export default __exports__